/* NoirClave Bundle Builder v5 — grid + desktop sticky summary + light mobile bar */
(function(){
  'use strict';

  var cfg = null;
  var state = { items: [] };

  function fmt(cents){ return '$' + (cents / 100).toFixed(2); }
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
  }); }

  function findItemIndex(vid){
    for(var i = 0; i < state.items.length; i++){
      if(state.items[i].vid === vid) return i;
    }
    return -1;
  }

  function calcState(){
    var subtotal = 0, qtyTotal = 0;
    state.items.forEach(function(it){
      subtotal += it.price * it.qty;
      qtyTotal += it.qty;
    });
    var pct = 0, currentTier = 0;
    if(qtyTotal >= cfg.tier2_min) { pct = cfg.tier2_pct; currentTier = 2; }
    else if(qtyTotal >= cfg.tier1_min) { pct = cfg.tier1_pct; currentTier = 1; }
    var discount = Math.round(subtotal * pct / 100);
    var finalPrice = subtotal - discount;
    var progressMax = cfg.tier2_min || 1;
    var progressRatio = Math.min(1, qtyTotal / progressMax);
    return { subtotal:subtotal, discount:discount, finalPrice:finalPrice, pct:pct,
      qtyTotal:qtyTotal, currentTier:currentTier, progressRatio:progressRatio };
  }

  function itemRowHtml(it){
    var variant = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
    return ''
      + '<div class="bs-row" data-vid="' + it.vid + '">'
        + '<img class="bs-row-img" src="' + esc(it.image) + '" alt="' + esc(it.title) + '" width="56" height="56" loading="lazy">'
        + '<div class="bs-row-info">'
          + '<span class="bs-row-title">' + esc(it.title) + '</span>'
          + (variant ? '<span class="bs-row-variant">' + esc(variant) + '</span>' : '')
          + '<span class="bs-row-price">' + fmt(it.price * it.qty) + '</span>'
        + '</div>'
        + '<div class="bs-row-actions">'
          + '<div class="bs-qty" role="group" aria-label="Quantity">'
            + '<button type="button" class="bs-qty-btn" data-bundle-qty-up="' + it.vid + '" aria-label="Increase">'
              + '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 15l-6-6-6 6"/></svg>'
            + '</button>'
            + '<span class="bs-qty-val">' + it.qty + '</span>'
            + '<button type="button" class="bs-qty-btn" data-bundle-qty-down="' + it.vid + '" aria-label="Decrease">'
              + '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"/></svg>'
            + '</button>'
          + '</div>'
          + '<button type="button" class="bs-row-remove" data-bundle-remove="' + it.vid + '">Remove</button>'
        + '</div>'
      + '</div>';
  }

  function renderItemsInto(container){
    if(!container) return;
    if(state.items.length === 0){ container.innerHTML = ''; return; }
    var html = '';
    state.items.forEach(function(it){ html += itemRowHtml(it); });
    container.innerHTML = html;
  }

  function render(){
    var s = calcState();

    var statusText = '';
    if(s.currentTier === 0){
      var need1 = cfg.tier1_min - s.qtyTotal;
      statusText = 'Add at least ' + need1 + ' more to save ' + cfg.tier1_pct + '%';
    } else if(s.currentTier === 1){
      var need2 = cfg.tier2_min - s.qtyTotal;
      statusText = 'Tier ' + cfg.tier1_pct + '% unlocked · Add ' + need2 + ' more for ' + cfg.tier2_pct + '%';
    } else {
      statusText = 'Best deal unlocked · ' + cfg.tier2_pct + '% off';
    }

    var section = document.querySelector('[data-bundle-section]');
    if(section) section.setAttribute('data-has-items', state.items.length > 0 ? '1' : '0');

    var summaries = document.querySelectorAll('[data-bundle-summary]');
    summaries.forEach(function(root){
      root.classList.toggle('is-empty', state.items.length === 0);
      root.classList.toggle('is-active', s.qtyTotal >= cfg.tier1_min);

      root.querySelectorAll('[data-bundle-status]').forEach(function(el){ el.textContent = statusText; });

      var pctStr = (s.progressRatio * 100).toFixed(2) + '%';
      root.querySelectorAll('[data-bundle-progress]').forEach(function(el){
        el.style.width = pctStr;
      });

      var itemsEl = root.querySelector('[data-bundle-items]');
      renderItemsInto(itemsEl);

      var strikeEls = root.querySelectorAll('[data-bundle-strike]');
      var saveEls   = root.querySelectorAll('[data-bundle-save]');
      var finalEls  = root.querySelectorAll('[data-bundle-final]');

      if(s.discount > 0){
        strikeEls.forEach(function(el){ el.textContent = fmt(s.subtotal); el.style.display = ''; });
        saveEls.forEach(function(el){ el.textContent = 'You save ' + fmt(s.discount) + ' (' + s.pct + '%)'; el.style.display = ''; });
      } else {
        strikeEls.forEach(function(el){ el.textContent = ''; el.style.display = 'none'; });
        saveEls.forEach(function(el){ el.textContent = ''; el.style.display = 'none'; });
      }
      finalEls.forEach(function(el){ el.textContent = fmt(s.finalPrice > 0 ? s.finalPrice : s.subtotal); });

      var checkoutEls = root.querySelectorAll('[data-bundle-checkout]');
      var ctaTextEls  = root.querySelectorAll('[data-bundle-cta-text]');
      var enabled = s.qtyTotal >= cfg.tier1_min;
      checkoutEls.forEach(function(el){ el.disabled = !enabled; });

      if(enabled){
        ctaTextEls.forEach(function(el){ el.textContent = 'Add to cart'; });
      } else if(s.qtyTotal === 0){
        ctaTextEls.forEach(function(el){ el.textContent = 'Add to cart'; });
      } else {
        var need = cfg.tier1_min - s.qtyTotal;
        ctaTextEls.forEach(function(el){ el.textContent = 'Add ' + need + ' more to unlock'; });
      }
    });

    document.querySelectorAll('[data-bundle-add]').forEach(function(btn){
      var vid = parseInt(btn.dataset.variantId, 10);
      var inBundle = findItemIndex(vid) >= 0;
      btn.classList.toggle('is-added', inBundle);
      var card = btn.closest('[data-bundle-card]');
      if(card) card.classList.toggle('is-in-bundle', inBundle);
    });
  }

  function addItem(btn){
    var vid = parseInt(btn.dataset.variantId, 10);
    var idx = findItemIndex(vid);
    if(idx >= 0){
      state.items[idx].qty += 1;
    } else {
      state.items.push({
        pid: parseInt(btn.dataset.productId, 10),
        vid: vid,
        title: btn.dataset.productTitle,
        vendor: btn.dataset.productVendor,
        variant_title: btn.dataset.variantTitle,
        price: parseInt(btn.dataset.variantPrice, 10),
        image: btn.dataset.productImage,
        qty: 1
      });
    }
    render();
  }

  function removeItem(vid){
    var idx = findItemIndex(vid);
    if(idx < 0) return;
    state.items.splice(idx, 1);
    render();
  }

  function incQty(vid){
    var idx = findItemIndex(vid);
    if(idx < 0) return;
    state.items[idx].qty += 1;
    render();
  }

  function decQty(vid){
    var idx = findItemIndex(vid);
    if(idx < 0) return;
    state.items[idx].qty -= 1;
    if(state.items[idx].qty <= 0) state.items.splice(idx, 1);
    render();
  }

  function addAllToCart(triggerBtn){
    if(state.items.length === 0) return;
    var allCheckoutBtns = document.querySelectorAll('[data-bundle-checkout]');
    var allCtaTexts     = document.querySelectorAll('[data-bundle-cta-text]');
    if(triggerBtn && triggerBtn.dataset.busy === '1') return;
    allCheckoutBtns.forEach(function(b){ b.dataset.busy = '1'; b.disabled = true; });

    var originalTexts = [];
    allCtaTexts.forEach(function(el, i){
      originalTexts[i] = el.textContent;
      el.textContent = 'Adding...';
    });

    var payload = { items: state.items.map(function(it){ return { id: it.vid, quantity: it.qty }; }) };

    // Shrine ProductForm pattern: request cart-drawer sections in the response
    var cartDrawer = document.querySelector('cart-drawer');
    if(cartDrawer && typeof cartDrawer.getSectionsToRender === 'function'){
      payload.sections = cartDrawer.getSectionsToRender().map(function(s){ return s.id; }).join(',');
      payload.sections_url = window.location.pathname;
      if(typeof cartDrawer.setActiveElement === 'function'){
        cartDrawer.setActiveElement(triggerBtn || document.body);
      }
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify(payload)
    })
    .then(function(r){
      if(!r.ok) return r.json().then(function(err){ throw err; });
      return r.json();
    })
    .then(function(response){
      // Use Shrine's native drawer refresh + open
      var drawer = document.querySelector('cart-drawer');
      if(drawer && typeof drawer.renderContents === 'function' && response && response.sections){
        // Shrine quirk: clean is-empty on outer <cart-drawer> before renderContents
        // to avoid trapFocus() crashing on the empty→items transition.
        if(drawer.classList.contains('is-empty')){
          drawer.classList.remove('is-empty');
        }
        drawer.renderContents(response);
      } else if(drawer && typeof drawer.open === 'function'){
        // Fallback: just open (drawer may or may not show new items)
        drawer.open(triggerBtn);
      }
      // If no cart-drawer element, silently succeed — items are added to cart
    })
        .then(function(){
      state.items = [];
      render();
      allCheckoutBtns.forEach(function(b){ b.dataset.busy = '0'; });
    })
    .catch(function(err){
      var msg = (err && err.description) ? err.description : 'Some items unavailable. Please try again.';
      allCtaTexts.forEach(function(el){ el.textContent = msg; });
      setTimeout(function(){
        allCtaTexts.forEach(function(el, i){ el.textContent = originalTexts[i] || 'Add to cart'; });
        allCheckoutBtns.forEach(function(b){ b.dataset.busy = '0'; });
        render();
      }, 3500);
    });
  }

  function bindSwatches(card){
    var swatches = card.querySelectorAll('[data-bundle-swatch]');
    if(!swatches.length) return;
    swatches.forEach(function(sw){
      sw.addEventListener('click', function(){
        card.querySelectorAll('[data-bundle-swatch]').forEach(function(x){ x.classList.remove('on'); });
        sw.classList.add('on');
        var btn = card.querySelector('[data-bundle-add]');
        var priceEl = card.querySelector('[data-bundle-price]');
        var imgEl = card.querySelector('[data-bundle-img]');
        var colorLabel = card.querySelector('[data-bundle-color]');
        if(btn){
          btn.dataset.variantId = sw.dataset.variantId;
          btn.dataset.variantTitle = sw.dataset.variantTitle;
          btn.dataset.variantPrice = sw.dataset.variantPrice;
          if(sw.dataset.variantImage) btn.dataset.productImage = sw.dataset.variantImage;
          render();
        }
        if(priceEl && sw.dataset.variantPrice) priceEl.textContent = fmt(parseInt(sw.dataset.variantPrice, 10));
        if(imgEl && sw.dataset.variantImage) imgEl.src = sw.dataset.variantImage;
        if(colorLabel) colorLabel.textContent = sw.dataset.variantTitle;
      });
    });
  }

  function bindMobileToggle(root){
    var head = root.querySelector('[data-bundle-mobile-toggle]');
    if(!head) return;
    head.addEventListener('click', function(){
      var open = root.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function setupHideOnView(){
    if(!cfg.hide_on_view_enabled) return;
    var selector = (cfg.hide_on_view_selector || '').trim();
    if(!selector) return;
    var section = document.querySelector('[data-bundle-section]');
    if(!section || !('IntersectionObserver' in window)) return;

    var targets = [];
    try { targets = Array.prototype.slice.call(document.querySelectorAll(selector)); }
    catch(e){ console.warn('[NC Bundle] invalid hide selector:', selector); return; }
    if(!targets.length) return;

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        var inView = en.isIntersecting;
        document.body.classList.toggle('nc-bundle-active', inView);
        targets.forEach(function(el){
          el.classList.toggle('nc-bundle-hidden', inView);
        });
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
    io.observe(section);
  }

  function init(){
    cfg = window.NC_BUNDLE_CFG;
    if(!cfg){ console.warn('[NC Bundle] NC_BUNDLE_CFG not set.'); return; }

    document.querySelectorAll('[data-bundle-summary]').forEach(function(root){
      root.addEventListener('click', function(e){
        var rm = e.target.closest('[data-bundle-remove]');
        if(rm){ e.preventDefault(); removeItem(parseInt(rm.dataset.bundleRemove, 10)); return; }
        var up = e.target.closest('[data-bundle-qty-up]');
        if(up){ e.preventDefault(); incQty(parseInt(up.dataset.bundleQtyUp, 10)); return; }
        var dn = e.target.closest('[data-bundle-qty-down]');
        if(dn){ e.preventDefault(); decQty(parseInt(dn.dataset.bundleQtyDown, 10)); return; }
        var co = e.target.closest('[data-bundle-checkout]');
        if(co){ e.preventDefault(); addAllToCart(co); return; }
      });
    });

    document.querySelectorAll('[data-bundle-mobile]').forEach(bindMobileToggle);

    document.querySelectorAll('[data-bundle-card]').forEach(function(card){
      bindSwatches(card);
      var addBtn = card.querySelector('[data-bundle-add]');
      if(addBtn){
        addBtn.addEventListener('click', function(){
          if(addBtn.disabled) return;
          var vid = parseInt(addBtn.dataset.variantId, 10);
          if(findItemIndex(vid) >= 0) removeItem(vid);
          else addItem(addBtn);
        });
      }
    });

    render();
    setupHideOnView();
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();